import { render, staticRenderFns } from "./LomTrainingQuestionEdit.vue?vue&type=template&id=e4bd8068"
import script from "./LomTrainingQuestionEdit.vue?vue&type=script&lang=js"
export * from "./LomTrainingQuestionEdit.vue?vue&type=script&lang=js"
import style0 from "./LomTrainingQuestionEdit.vue?vue&type=style&index=0&id=e4bd8068&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports